import ACTION_TYPES from '../../constants/actionTypes';

export function updatePartnerInfo(authToken, partnerInfo) {
  return {
    type: ACTION_TYPES.UPDATE_PARTNER_INFO,
    authToken,
    partnerInfo,
  };
}
